import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InterventionSoilCreateDto,
  InterventionSoilUpdateDto,
} from '../proxy/geographic/dtos/intervention-soil';
import { INTERVENTIONSOIL_CONFIG, INTERVENTIONSOIL_FIELDS } from './intervention-soil.config';
import { BaseHierarchicalCrudComponent, GenericForm, ICrudService, ZnHierarchicalViewComponent } from '@zendra/shared';
import { InterventionSoilService } from '../proxy/geographic/controllers';
import { InterventionSoilProjectionPlanningOrchestratorService } from 'orchestrator';
import {
  GetInterventionSoilProjectionListInputDto,
  InterventionSoilProjectionDto,
  InterventionSoilProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/intervention-soils/models';

@Component({
  selector: 'app-intervention-soil',
  imports: [
    ZnHierarchicalViewComponent,
    GenericForm,
  ],
  providers: [ListService, InterventionSoilService, ConfirmationService],
  templateUrl: './intervention-soil.html',
  styleUrl: './intervention-soil.scss',
})
export class InterventionSoil extends BaseHierarchicalCrudComponent<
  InterventionSoilProjectionDto,
  InterventionSoilCreateDto,
  InterventionSoilUpdateDto,
  InterventionSoilProjectionExcelDownloadDto
> {
  private readonly geographicService = inject(InterventionSoilService);
  private readonly orchestratorService = inject(InterventionSoilProjectionPlanningOrchestratorService);

  service: ICrudService<
    InterventionSoilProjectionDto,
    InterventionSoilCreateDto,
    InterventionSoilUpdateDto,
    InterventionSoilProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'interventionSoilId',
    ),
    getList: (query: GetInterventionSoilProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
  };

  config = INTERVENTIONSOIL_CONFIG;
  fields = INTERVENTIONSOIL_FIELDS;

  protected prepareUpdateDto(
    data: any,
    selected: InterventionSoilProjectionDto,
  ): InterventionSoilUpdateDto {
    return {
      isForestPriority: data.isForestPriority,
      soilArea: data.soilArea,
      soilPercentage: data.soilPercentage,
      interventionId: data.interventionId,
      registerId: data.registerId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InterventionSoil';
  }
}
